/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EdrOrgDetails } from './edrOrgDetails';


export interface OnPremEdrOrgsListResponse { 
    edr_orgs: Array<EdrOrgDetails>;
}

